module.exports = __webpack_public_path__ + "static/slider_2-3fbcb23b6edf4fd8b30c589d0bd2e974.jpg";